/**
 * 📌 ISH REJASI paneli — 🧠 Agent suhbatining tepasida qadalib turadi (backend: services/operatorPlans.js, docs/knowledge/196).
 * Operator: «reja suhbat davomida tepada qolib ketadi — pin qilish, «1-chini bajardik, endi 2 ga o'tamiz» deyish,
 * bajarilganini belgilash imkoni bo'lsin».
 *
 *  · Ixcham qator: nom, 17/22, chiziq, «Hozir ▶ 18. …» + ▶ Bajar / ✅ / ⏭. ▾ — bo'limlar bo'yicha to'liq ro'yxat.
 *  · ▶ Bajar — agentga operator nomidan buyruq (server qadamni ▶ qiladi). Belgini agent o'zi qo'yadi (plan_step),
 *    siz bu yerdan tuzatasiz: ✅ / ⚠️ / ⏭ / ⬜, ichki bandlar katakchalari.
 *  · ⏩ O'zi davom etsin — qadam ✅ bo'lgach keyingisi o'zi yuboriladi (sukut bo'yicha o'chiq).
 *  · ↗ — qadam belgilangan agent javobiga suhbatda o'tish.
 */
import React, { useState } from 'react';
import { toast } from 'react-hot-toast';

const ICON = { todo: '⬜', doing: '▶', done: '✅', issue: '⚠️', skip: '⏭' };
const LABEL = { todo: 'Kutilmoqda', doing: 'Hozir', done: 'Bajarildi', issue: 'Muammo', skip: "O'tkazildi" };
const lsGet = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
const lsSet = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { } };
// Matnda kamida 2 ta raqamlangan qator bo'lsa — javob ostida «📌 Reja qilib qadash» chiqadi.
export const looksLikePlan = (text) => (String(text || '').match(/^\s{0,1}\d{1,3}[.)]\s+\S/gm) || []).length >= 2;

function groups(steps) {
  const out = [];
  for (const s of steps || []) {
    let g = out[out.length - 1];
    if (!g || g.name !== s.section) { g = { name: s.section, steps: [] }; out.push(g); }
    g.steps.push(s);
  }
  return out;
}
const B = 'px-2 py-0.5 rounded text-xs font-medium transition disabled:opacity-40';

export default function PlanBar({ authFetch, apiUrl, projectId, plan, onPlan, busy = false, onJump, history = [], onReloadHistory, threadId = null }) {
  const lsKey = `kh_plan_open_${projectId}`;
  const [open, setOpenRaw] = useState(() => lsGet(lsKey) === '1');
  const setOpen = (v) => { setOpenRaw(v); lsSet(lsKey, v ? '1' : '0'); };
  const [menuN, setMenuN] = useState(null);        // holat menyusi ochiq qadam
  const [showHist, setShowHist] = useState(false);
  const [pending, setPending] = useState(false);
  const base = `${apiUrl}/operator/${projectId}/plans`;

  const call = async (url, method, body) => {
    setPending(true);
    try {
      const r = await authFetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { toast.error(d.error || 'Xatolik'); return null; }
      if (d.plan !== undefined && onPlan) onPlan(d.plan && d.plan.status === 'active' ? d.plan : (d.plan && d.plan.status === 'done' ? d.plan : null));
      return d;
    } catch (e) { toast.error("Ulanib bo'lmadi"); return null; }
    finally { setPending(false); }
  };

  if (!plan) {
    if (!history.length) return null;
    return (
      <div className="shrink-0 px-3 py-1 border-b border-gray-200 dark:border-gray-700 text-[11px] text-gray-500 dark:text-gray-400 flex items-center gap-2">
        <span>📌 Faol reja yo'q</span>
        <button type="button" onClick={() => setShowHist(v => !v)} className="underline hover:text-gray-800 dark:hover:text-gray-200">📚 Rejalar ({history.length})</button>
        {showHist && <HistList history={history} onActivate={async (id) => { await call(`${base}/${id}`, 'PATCH', { status: 'active' }); setShowHist(false); onReloadHistory && onReloadHistory(); }} />}
      </div>
    );
  }

  const pr = plan.progress || { done: 0, total: 0, pct: 0, issues: 0 };
  const cur = (plan.steps || []).find(s => s.n === plan.current) || null;
  const finished = plan.status === 'done' || (!cur && pr.total > 0);
  const setStep = (n, patch) => call(`${base}/${plan.id}/step`, 'POST', { n, ...patch });
  const run = async (n) => { setMenuN(null); const d = await call(`${base}/${plan.id}/run`, 'POST', { n }); if (d) toast.success(`▶ ${n}-qadam agentga yuborildi`); };
  const rename = async () => {
    const t = window.prompt('Reja nomi', plan.title);
    if (t && t.trim() && t.trim() !== plan.title) await call(`${base}/${plan.id}`, 'PATCH', { title: t.trim() });
  };
  const toggleAuto = () => call(`${base}/${plan.id}`, 'PATCH', { autoContinue: !plan.autoContinue })
    .then(d => d && toast(d.plan.autoContinue ? "⏩ O'zi davom etadi: qadam ✅ bo'lgach keyingisi o'zi yuboriladi" : "⏸ Har qadamdan keyin agent sizni kutadi"));
  const unpin = async () => {
    if (!window.confirm(`«${plan.title}» rejasini tepadan olib, 📚 Rejalar ro'yxatiga qo'yamizmi? (o'chmaydi)`)) return;
    await call(`${base}/${plan.id}`, 'PATCH', { status: 'archived' });
    if (onPlan) onPlan(null);
    onReloadHistory && onReloadHistory();
  };
  const remove = async () => {
    if (!window.confirm(`«${plan.title}» rejasini butunlay o'chirasizmi?`)) return;
    const d = await call(`${base}/${plan.id}`, 'DELETE');
    if (d && onPlan) onPlan(null);
    onReloadHistory && onReloadHistory();
  };
  const issuesTask = async () => {
    const iss = (plan.steps || []).filter(s => s.status === 'issue');
    if (!iss.length) return;
    const text = `🛠 📌 «${plan.title}» rejasidagi ⚠️ muammoli qadamlar bo'yicha tuzatish vazifasini tayyorlang (kod o'zgarishi kerak bo'lganlari; qolganlarini ayting):\n`
      + iss.map(s => `- ${s.n}. ${s.text}${s.note ? ` — ${s.note}` : ''}`).join('\n');
    const r = await authFetch(`${apiUrl}/operator/${projectId}/chat`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ text, thread: threadId || undefined }) });
    if (r.ok) toast.success('🛠 Agentga yuborildi'); else toast.error('Yuborilmadi');
  };

  const bar = (
    <div className="h-1.5 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden flex-1 min-w-[40px]">
      <div className={`h-full ${finished ? 'bg-emerald-500' : 'bg-primary-600'} transition-all`} style={{ width: `${pr.pct}%` }} />
    </div>
  );

  return (
    <div className={`shrink-0 border-b border-gray-200 dark:border-gray-700 bg-amber-50/60 dark:bg-amber-900/10 ${open ? 'max-h-[55%] flex flex-col' : ''}`}>
      {/* Sarlavha qatori */}
      <div className="px-3 pt-1.5 flex items-center gap-2 text-xs">
        <button type="button" onClick={() => setOpen(!open)} className="min-w-0 flex items-center gap-1.5 font-semibold text-gray-900 dark:text-gray-100" title={open ? "Yig'ish" : "To'liq rejani ochish"}>
          <span>📌</span><span className="truncate" translate="no">{plan.title}</span>
        </button>
        <button type="button" onClick={rename} title="Nomini o'zgartirish" className="shrink-0 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200">✏️</button>
        <span className="shrink-0 tabular-nums text-gray-600 dark:text-gray-300" title={`${pr.done} ta bajarildi / o'tkazildi, jami ${pr.total}`}>{pr.done}/{pr.total}</span>
        {bar}
        {pr.issues > 0 && <span className="shrink-0 text-amber-700 dark:text-amber-400" title="Muammoli qadamlar">⚠️{pr.issues}</span>}
        {plan.autoContinue && <span className="shrink-0" title="O'zi davom etadi">⏩</span>}
        <button type="button" onClick={() => setOpen(!open)} className="shrink-0 px-1 text-gray-500 hover:text-gray-900 dark:hover:text-white">{open ? '▴' : '▾'}</button>
      </div>
      {/* Hozirgi qadam */}
      <div className="px-3 pb-1.5 pt-1 flex items-center gap-1.5 text-xs flex-wrap">
        {finished ? (
          <>
            <span className="font-medium text-emerald-700 dark:text-emerald-400">🏁 Reja tugadi — {pr.done}/{pr.total}{pr.issues ? ` · ⚠️ ${pr.issues} ta muammo` : ''}</span>
            {pr.issues > 0 && <button type="button" onClick={issuesTask} className={`${B} bg-primary-700 text-white hover:bg-primary-800`} title="⚠️ qadamlar bo'yicha agentga tuzatish vazifasini tayyorlatish">🛠 Muammolardan vazifa</button>}
            <button type="button" onClick={unpin} className={`${B} border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-800`}>📚 Arxivga</button>
          </>
        ) : cur && (
          <>
            <span className="min-w-0 flex-1 truncate text-gray-800 dark:text-gray-200" title={cur.text}>
              <span className="text-gray-500 dark:text-gray-400">Hozir</span> {ICON[cur.status]} <b>{cur.n}.</b> {cur.text}
              {cur.sub && cur.sub.length > 0 && <span className="text-gray-500"> ({cur.sub.filter(x => x.done).length}/{cur.sub.length})</span>}
            </span>
            <button type="button" onClick={() => run(cur.n)} disabled={pending} title={busy ? "Agent hozir band — buyruq navbatga tushadi" : "Shu qadamni agentga bajartirish"}
              className={`${B} bg-primary-700 text-white hover:bg-primary-800`}>▶ Bajar</button>
            <button type="button" onClick={() => setStep(cur.n, { status: 'done' })} disabled={pending} title="Bajarildi deb belgilash" className={`${B} bg-emerald-600 text-white hover:bg-emerald-700`}>✅</button>
            <button type="button" onClick={() => setStep(cur.n, { status: 'skip' })} disabled={pending} title="O'tkazib yuborish" className={`${B} border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-800`}>⏭</button>
          </>
        )}
      </div>
      {/* To'liq ro'yxat */}
      {open && (
        <div className="min-h-0 overflow-auto px-3 pb-2 border-t border-amber-200/60 dark:border-amber-900/40">
          {groups(plan.steps).map((g, gi) => {
            const d = g.steps.filter(s => s.status === 'done' || s.status === 'skip').length;
            return (
              <div key={gi} className="mt-2">
                {g.name && <div className={`text-[11px] font-semibold mb-0.5 ${d === g.steps.length ? 'text-emerald-700 dark:text-emerald-400' : 'text-gray-700 dark:text-gray-300'}`} translate="no">{d === g.steps.length ? '✅ ' : ''}{g.name} <span className="font-normal text-gray-500">{d}/{g.steps.length}</span></div>}
                {g.steps.map(s => (
                  <div key={s.n} className={`relative group rounded px-1 py-0.5 text-xs ${s.n === plan.current ? 'bg-primary-50 dark:bg-primary-900/30' : 'hover:bg-white/70 dark:hover:bg-gray-800/60'}`}>
                    <div className="flex items-start gap-1.5">
                      <button type="button" onClick={() => setMenuN(menuN === s.n ? null : s.n)} title={`${LABEL[s.status]} — bosib holatni o'zgartiring`} className="shrink-0 w-5 text-center leading-5">{ICON[s.status] || '⬜'}</button>
                      <div className="min-w-0 flex-1">
                        <span className={s.status === 'done' || s.status === 'skip' ? 'text-gray-500 dark:text-gray-400' : 'text-gray-900 dark:text-gray-100'}><b>{s.n}.</b> {s.text}</span>
                        {s.note && <div className={`text-[11px] ${s.status === 'issue' ? 'text-amber-700 dark:text-amber-400' : 'text-gray-500 dark:text-gray-400'}`}>↳ {s.note}</div>}
                        {s.sub && s.sub.length > 0 && (
                          <div className="flex flex-wrap gap-x-3 gap-y-0.5 mt-0.5">
                            {s.sub.map((x, i) => (
                              <label key={i} className="inline-flex items-center gap-1 text-[11px] text-gray-600 dark:text-gray-300 cursor-pointer">
                                <input type="checkbox" checked={!!x.done} disabled={pending}
                                  onChange={() => setStep(s.n, { sub: s.sub.map((y, j) => (j === i ? !y.done : !!y.done) ? j : -1).filter(j => j >= 0) })} />
                                {x.text}
                              </label>
                            ))}
                          </div>
                        )}
                      </div>
                      {s.msgId && <button type="button" onClick={() => onJump && onJump(s.msgId)} title="Agent shu qadamni belgilagan javobga o'tish" className="shrink-0 text-gray-400 hover:text-primary-600">↗</button>}
                      <button type="button" onClick={() => run(s.n)} disabled={pending} title={`${s.n}-qadamni agentga bajartirish`} className="shrink-0 opacity-0 group-hover:opacity-100 text-primary-700 dark:text-primary-400 font-semibold">▶</button>
                    </div>
                    {menuN === s.n && (
                      <div className="mt-1 ml-6 flex flex-wrap gap-1">
                        <button type="button" onClick={() => run(s.n)} className={`${B} bg-primary-700 text-white`}>▶ Bajar</button>
                        {['done', 'issue', 'skip', 'todo'].filter(k => k !== s.status).map(k => (
                          <button key={k} type="button" onClick={async () => {
                            let note;
                            if (k === 'issue') { note = window.prompt('Muammo nimada? (qisqa)', s.note || ''); if (note === null) return; }
                            setMenuN(null); await setStep(s.n, { status: k, ...(note != null ? { note } : {}) });
                          }} className={`${B} border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-white dark:hover:bg-gray-800`}>{ICON[k]} {LABEL[k]}</button>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            );
          })}
          <div className="mt-2 pt-1.5 border-t border-amber-200/60 dark:border-amber-900/40 flex items-center gap-2 flex-wrap text-[11px]">
            <label className="inline-flex items-center gap-1 cursor-pointer text-gray-700 dark:text-gray-300" title="Qadam ✅ bo'lgach agent keyingisiga o'zi o'tadi. Sizdan ma'lumot kerak bo'lsa yoki ✅ tasdiq tugmasi oldida to'xtaydi.">
              <input type="checkbox" checked={!!plan.autoContinue} onChange={toggleAuto} disabled={pending} /> ⏩ O'zi davom etsin
            </label>
            {history.length > 1 && <button type="button" onClick={() => setShowHist(v => !v)} className="underline text-gray-500 hover:text-gray-800 dark:hover:text-gray-200">📚 Rejalar ({history.length})</button>}
            <span className="ml-auto" />
            <button type="button" onClick={unpin} className="text-gray-500 hover:text-gray-800 dark:hover:text-gray-200" title="Tepadan olib, arxivga qo'yish (o'chmaydi)">📚 Arxivga</button>
            <button type="button" onClick={remove} className="text-red-500 hover:text-red-700" title="Rejani butunlay o'chirish">🗑</button>
          </div>
          {showHist && <HistList history={history.filter(h => h.id !== plan.id)} onActivate={async (id) => { await call(`${base}/${id}`, 'PATCH', { status: 'active' }); setShowHist(false); onReloadHistory && onReloadHistory(); }} />}
        </div>
      )}
    </div>
  );
}

function HistList({ history, onActivate }) {
  if (!history.length) return null;
  return (
    <div className="mt-1 w-full space-y-0.5">
      {history.map(h => (
        <div key={h.id} className="flex items-center gap-2 text-[11px] text-gray-600 dark:text-gray-300">
          <span className="truncate" translate="no">{h.status === 'done' ? '🏁' : '📌'} {h.title}</span>
          <span className="shrink-0 tabular-nums text-gray-400">{h.progress ? `${h.progress.done}/${h.progress.total}` : ''}</span>
          <button type="button" onClick={() => onActivate(h.id)} className="shrink-0 underline hover:text-primary-600">tepaga qadash</button>
        </div>
      ))}
    </div>
  );
}
